import { createApiAction, createPaginationAction } from './common'

export const getFirmwareList = createPaginationAction('get firmware version list')
export const createFirmwareVersion = createApiAction('create firmware version')
export const removeFirmwareVersion = createApiAction('remove firmware version')
export const updateClientVersion = createApiAction('update client version')
export const getClientVersion = createApiAction('get client version')
